import { useNavigate, useParams } from "react-router-dom";
import svg from "../components/svg";
import React, { useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { useDispatch, useSelector, } from "react-redux";
import CampaignService from "../service/CampaignService";
import PageService from "../service/PageService";
import AlertSetting from "../components/AlertSetting";
import ProductService from "../service/ProductService";
import PageSetting from "../components/PageSetting";
import { removeState } from "../redux/slices/commonSlice";
import ProjectService from "../service/ProjectService";
import { toast } from "react-toastify";
import Loader from "../components/common/Loader";
import PublicUrl from "../components/PublishUrl";

export default function CreateCamapign() {

    const [activeTab, setActiveTab] = useState("tab1")
    const [campaignName, setCampaignName] = useState()
    const [campaignDetails, setcampaignDetails] = useState()
    const [products, setProducts] = useState([])
    const [projects, setProjects] = useState([])
    const [selectedAlert, setSelectedAlert] = useState()
    const [pageSettings, setPageSettings] = useState([])
    const [loading, setLoading] = useState(false);
    const [publishData, setPublishData] = useState([]);
    const [isPublishedUrlLoading, setIsPublishedUrlLoading] = useState(false)

    const userDetails = useSelector((data) => data.common)
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();

    useEffect(() => {
        if (!id) return;
        setLoading(true)
        getCampaign({ user_id: userDetails.user.id, token: userDetails.token, prof_campaign_id: id, onTabChange:false })
        getPageSettings({ user_id: userDetails.user.id, token: userDetails.token, prof_campaign_id: id })
        getPublishUrlData({ user_id: userDetails.user.id, token: userDetails.token, prof_campaign_id: id })
    }, [id])

    useEffect(() => {
        if (!userDetails.user) return
        getProducts({ user_id: userDetails.user.id, token: userDetails.token })
        getProjects({ user_id: userDetails.user.id, token: userDetails.token })
    }, [userDetails.user])

    const handleTabSelect = (tab) => {
        setActiveTab(tab)
        setIsPublishedUrlLoading(false)
    }

    const getAlertSettings = (formData) => {
        let camapaignDetails = formData.campaign
        delete formData.campaign
        PageService.getAlertSettings(formData).then(resp => {
            if (resp.data.success) {
                let productIds = []
                let salesPageIds = []
                let salesPages = []
                let leadPageIds = []
                let visitorPageIds = []
                let visitorPages = []
                let leadPages = []
                let saleProducts = []

                resp?.data?.campaign_alert_settings?.map(async (setting) => {
                    if (setting.alert_type === "sale") {
                        productIds = JSON.parse(setting.product_id);
                        saleProducts = getProduct1({ user_id: userDetails.user.id, token: userDetails.token })
                        salesPageIds = JSON.parse(setting.funnel_page_id)
                        salesPages = getPages1({ user_id: userDetails.user.id, token: userDetails.token, funnel_id: setting.funnel_id, type: "sale" })
                    } else if (setting.alert_type === "lead") {
                        leadPageIds = JSON.parse(setting.funnel_page_id)
                        leadPages = getPages1({ user_id: userDetails.user.id, token: userDetails.token, funnel_id: setting.funnel_id, type: "lead" })
                    } else if (setting.alert_type === "visitor") {
                        visitorPageIds = JSON.parse(setting.funnel_page_id)
                        visitorPages = getPages1({ user_id: userDetails.user.id, token: userDetails.token, funnel_id: setting.funnel_id, type: "visitor" })
                    }
                    setting.alert_customization = JSON.parse(setting.alert_customization)
                })

                let salesProducts = []
                let salesSelectedPages = []
                let leadSelectedPage = []
                let visitorSelectedPage = []

                if (productIds?.length > 0) {
                    saleProducts?.then(products => {
                        products?.map(product => {
                            productIds?.map(id => {
                                if (product.product_id === id) {
                                    product.checked = true
                                    salesProducts.push(product)
                                }
                            })
                        })
                    })
                }
                
                if (leadPageIds?.length > 0) {
                    leadPages?.then(pages => {
                        pages?.map(page => {
                            leadPageIds?.map(id => {
                                if (page.funnel_page_id === id) {
                                    page.checked = true
                                    leadSelectedPage.push(page)
                                }
                            })
                        })
                    })
                }

                if (visitorPageIds?.length > 0) {
                    visitorPages?.then(pages => {
                        pages?.map(page => {
                            visitorPageIds?.map(id => {
                                if (page.funnel_page_id === id) {
                                    page.checked = true
                                    visitorSelectedPage.push(page)
                                }
                            })
                        })
                    })

                }
               resp?.data?.campaign_alert_settings?.map(setting => {
                    if (setting.alert_type === "sale") {
                        setting["alertType"] = "sale"
                        setting["products"] = salesProducts
                        setting["funnel_id"] = setting?.funnel_id
                        setting["pages"] = JSON.parse(setting?.funnel_page_id)
                        setting.funnel_page_id = JSON.parse(setting?.funnel_page_id)
                    } else if (setting.alert_type === "lead") {
                        setting["alertType"] = "lead"
                        setting["funnel_id"] = setting?.funnel_id
                        setting["pages"] = leadSelectedPage
                    } else if (setting.alert_type === "visitor") {
                        setting["alertType"] = "visitor"
                        setting["funnel_id"] = setting?.funnel_id
                        setting["pages"] = visitorSelectedPage
                    }
                })
                camapaignDetails['alertSettings'] = resp.data.campaign_alert_settings
                setcampaignDetails({ ...camapaignDetails })
                if (formData?.onTabChange) {
                    setActiveTab("tab3")
                } else {
                    setActiveTab("tab2")
                }
                setTimeout(() => {
                    setLoading(false)
                },500)
            }
        }).catch(error => {
            setLoading(false)
        });
    }

    const getCampaign = (formData) => {
        CampaignService.getCampaign(formData).then(resp => {
            if (resp.data.success) {
                setCampaignName(resp?.data?.campaign_details.name)
                getAlertSettings({ user_id: userDetails?.user.id, token: userDetails?.token, prof_campaign_id: resp?.data?.campaign_details.prof_campaign_id, campaign: resp?.data?.campaign_details, onTabChange:formData.onTabChange })
            }
        }).catch(error => {
          
            setLoading(false)
        });
    }

    const getProducts = (formData) => {
        ProductService.getProducts(formData).then(resp => {
            if (resp.data.success) {
                setProducts(resp?.data?.product_list)
            }
        }).catch(error => {
         
        });
    }

    const getPublishUrlData = (formData) => {
        CampaignService.getPublishUrl(formData).then(resp => {
            if (resp.data.success) {
                setPublishData(resp.data.campaign_published_page_url)
            }
        })
    }

    const getProjects = (formData) => {
        ProjectService.getProjects(formData).then(resp => {
            if (resp.data.success) {
                setProjects(resp?.data?.project_list)
            }
        }).catch(error => {
        });
    }

    const getProduct1 = (formData) => {
        return new Promise((resolve, reject) => {
            ProductService.getProducts(formData)
                .then((resp) => {
                    if (resp.data.success) {
                        let updatedProduct = resp.data.product_list.map((data) => {
                            data["checked"] = false;
                            return data;
                        });
                        resolve(updatedProduct);
                    } else {
                        reject(new Error("Failed to fetch pages"));
                    }
                }).catch(error => {
                    // reject(error);
                    // if (error.response.status == 401) {
                    //     toast.error(error.message)
                    //     dispatch(removeState())
                    //     navigate("/")
                    // }
        
                });
        });
    };

    const getPages1 = (formData) => {
        return new Promise((resolve, reject) => {
            PageService.getPages(formData)
                .then((resp) => {
                    if (resp.data.success) {
                        let updatedPages = resp.data.page_list.map((data) => {
                            data["checked"] = false;
                            return data;
                        });
                        resolve(updatedPages); // Resolve the Promise with updatedPages
                    } else {
                        reject(new Error("Failed to fetch pages")); // Reject the Promise if the response is not successful
                    }
                })
                .catch((error) => {
                    reject(error); // Reject the Promise if an error occurs
                });
        });
    };

    const getPageSettings = (formData) => {
        PageService.getPageSettings(formData).then(resp => {
            if (resp.data.status) {
                resp.data.campaign_page_settings.map(setting => {
                    setting.page_customization = JSON.parse(setting.page_customization)
                })
                setPageSettings(resp.data.campaign_page_settings)
            }
        }).catch(error => {
        });
    }

    const createCamapign = () => {
        if(!campaignName){
            toast.error('Please insert campaign name');
            return
        }
        if (!userDetails?.token) return
        if (id && campaignName === campaignDetails?.name) {
            setActiveTab("tab2")
            return
        }

        if (campaignName === campaignDetails?.name) {
            setActiveTab("tab2")
            return
        }

        let formData = {
            prof_campaign_id : id && id,
            name: campaignName,
            user_id: userDetails?.user?.id,
            token: userDetails?.token,
        }

        if(!id){
            delete formData.prof_campaign_id
        }

        CampaignService.createCampaign(formData).then(resp => {
            if (resp.data.success) {
                setCampaignName(resp?.data?.campaign_details.name)
                setcampaignDetails(resp?.data?.campaign_details)
                getPageSettings({ user_id: userDetails.user.id, token: userDetails.token, prof_campaign_id: resp?.data?.campaign_details.prof_campaign_id })
                setActiveTab("tab2")
            }
        }).catch(error => {
            // if (error.response.status == 401) {
            //     dispatch(removeState())
            //     navigate("/")
            // }
               setLoading(false)
        });
    }

    const selectedAlertType = (data) => {
          setSelectedAlert(data)
    }

    const handleCamapaignUpdate = (data) => {
           let formData = {
            prof_campaign_id : id && id,
            name: campaignName,
            user_id: userDetails?.user?.id,
            token: userDetails?.token,
            alerts :{
                sale_alert : data?.saleAlert || false,
                lead_alert : data?.leadAlert || false,
                visitor_alert : data?.visitorAlert || false
            }
        }
        CampaignService.createCampaign(formData).then(resp => {
            if (resp.data.success) {
                setCampaignName(resp?.data?.campaign_details.name)
                setcampaignDetails(resp?.data?.campaign_details)
                getPageSettings({ user_id: userDetails.user.id, token: userDetails.token, prof_campaign_id: resp?.data?.campaign_details.prof_campaign_id })
                setActiveTab("tab2")
            }
        }).catch(error => {
            // if (error.response.status == 401) {
            //     dispatch(removeState())
            //     navigate("/")
            // }

        });

    }

    const getType = (type) => {
        if (type === "Leads Alert") {
            return "lead"
        } else if (type === "Sales Alert") {
            return "sale"
        } else if (type === "Visitor Alert") {
            return "visitor"
        }
    }

    const handleTabChange = async (data) => {
        setLoading(true)
        getCampaign({ user_id: userDetails.user.id, token: userDetails.token, prof_campaign_id: data.prof_campaign_id, onTabChange:true })
        getPageSettings({ user_id: userDetails.user.id, token: userDetails.token, prof_campaign_id:  data.prof_campaign_id })
        getPublishUrlData({ user_id: userDetails.user.id, token: userDetails.token, prof_campaign_id:  data.prof_campaign_id })
     
    }

    return (
        <>
             {loading && <Loader />}
            <div className="fp-main-content">
                <div className="fp-page-container">
                    <div className="fp-go-back-btn-wrap">
                        <Link to="/">
                            <span>
                                {svg.app.backIcon}
                            </span>
                           
                            {/* {id ?` Update Campaign - ${campaignDetails?.name}`  : `New Campaign ${ campaignDetails?.name ?  `- ${campaignDetails?.name}` : ""}`} */}
                        </Link>
                        <span>{id ? "Update Campaign - " : "New Campaign"}</span>
                            <span className="camp_color">{id ? campaignDetails?.name : (campaignDetails?.name && `- ${campaignDetails?.name}`) }</span>
                    </div>
                    <div className="fp-camp-tab-wrapper">
                        <Tabs defaultActiveKey="tab1" activeKey={activeTab} onSelect={handleTabSelect} className="tab-menu">
                            <Tab eventKey="tab1" title={
                                    <div className="fp_front_icons">
                                        <svg width="23px" height="23px" version="1.1" x="0" y="0" viewBox="0 0 512 512"><g><path fillRule="evenodd" d="m202.184 388.111 48.586 48.586c5.842 5.842 5.842 15.371 0 21.213l-20.045 20.045c-5.842 5.842-15.371 5.842-21.213 0l-59.988-59.988 46.141-26.64a531.777 531.777 0 0 1 6.519-3.216zm291.529-184.107c6.293 2.046 9.736 8.807 7.69 15.1-2.047 6.293-8.807 9.736-15.1 7.69l-43.637-14.178c-6.293-2.046-9.736-8.807-7.69-15.1s8.807-9.736 15.1-7.689zm-49.419-64.188c-5.74 3.314-13.079 1.347-16.392-4.393-3.314-5.739-1.347-13.079 4.392-16.392l39.415-22.757c5.74-3.314 13.079-1.347 16.392 4.392 3.314 5.74 1.347 13.079-4.392 16.393zM377.973 39.16c1.374-6.473 7.736-10.606 14.21-9.232 6.473 1.374 10.606 7.736 9.232 14.21l-9.541 44.88c-1.374 6.473-7.736 10.606-14.209 9.232s-10.606-7.736-9.232-14.209zM252.542 52.921c-11.463 6.618-15.428 21.414-8.809 32.877l131.543 227.84c6.619 11.464 21.414 15.427 32.878 8.809 11.463-6.618 15.427-21.414 8.809-32.877l-44.751-77.51 5.849-3.377c20.387-11.771 27.437-38.081 15.667-58.469-11.771-20.387-38.082-27.437-58.469-15.667l-5.849 3.377-43.991-76.195c-6.618-11.461-21.413-15.426-32.877-8.808zM29.124 360.719l10.483 18.158c17.823 30.87 57.662 41.545 88.533 23.722l45.78-26.431-85.777-148.57-45.78 26.431c-30.87 17.823-41.545 57.662-23.722 88.532zm79.308-145.772c49.664-34.11 87.897-72.052 117.556-111.883l124.703 215.993c-49.324 5.769-101.3 19.91-155.672 45.865z" clipRule="evenodd" opacity="1"/></g></svg>
                                        <span>Campaign</span>
                                    </div>
                                    }>
                                <div className="fp-camp-step1">
                                    <div className="tab-main-box">
                                        <div className="tab-create-camp-wrapper">
                                            <div className="fp-create-camp-heading">
                                                <span>
                                                    <svg width="26px" height="26px" version="1.1" x="0" y="0" viewBox="0 0 512 512"><g><path fillRule="evenodd" d="m202.184 388.111 48.586 48.586c5.842 5.842 5.842 15.371 0 21.213l-20.045 20.045c-5.842 5.842-15.371 5.842-21.213 0l-59.988-59.988 46.141-26.64a531.777 531.777 0 0 1 6.519-3.216zm291.529-184.107c6.293 2.046 9.736 8.807 7.69 15.1-2.047 6.293-8.807 9.736-15.1 7.69l-43.637-14.178c-6.293-2.046-9.736-8.807-7.69-15.1s8.807-9.736 15.1-7.689zm-49.419-64.188c-5.74 3.314-13.079 1.347-16.392-4.393-3.314-5.739-1.347-13.079 4.392-16.392l39.415-22.757c5.74-3.314 13.079-1.347 16.392 4.392 3.314 5.74 1.347 13.079-4.392 16.393zM377.973 39.16c1.374-6.473 7.736-10.606 14.21-9.232 6.473 1.374 10.606 7.736 9.232 14.21l-9.541 44.88c-1.374 6.473-7.736 10.606-14.209 9.232s-10.606-7.736-9.232-14.209zM252.542 52.921c-11.463 6.618-15.428 21.414-8.809 32.877l131.543 227.84c6.619 11.464 21.414 15.427 32.878 8.809 11.463-6.618 15.427-21.414 8.809-32.877l-44.751-77.51 5.849-3.377c20.387-11.771 27.437-38.081 15.667-58.469-11.771-20.387-38.082-27.437-58.469-15.667l-5.849 3.377-43.991-76.195c-6.618-11.461-21.413-15.426-32.877-8.808zM29.124 360.719l10.483 18.158c17.823 30.87 57.662 41.545 88.533 23.722l45.78-26.431-85.777-148.57-45.78 26.431c-30.87 17.823-41.545 57.662-23.722 88.532zm79.308-145.772c49.664-34.11 87.897-72.052 117.556-111.883l124.703 215.993c-49.324 5.769-101.3 19.91-155.672 45.865z" clipRule="evenodd" opacity="1"/></g></svg>        
                                                </span>
                                                <h4>Campaign</h4>
                                            </div>
                                            <div className="fp-create-camp-body">
                                                <div className="fp-frm-wrapper">
                                                    <div className="fp-input-wrap mb-30">
                                                        <label>Campaign Name</label>
                                                        <input type="text" placeholder="Campaign Name" value={campaignName || ''} onChange={(e) => setCampaignName(e.target.value)} />
                                                    </div>
                                                    <span className="text-danger">{alert.message}</span>
                                                    <div className="fp-btn-wrap fp-creat-camp">
                                                        <Link to="#" className="fp-btn" onClick={createCamapign}>
                                                            Next
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="tab2" title={
                                <div className="fp_front_icons">
                                    <svg width="17px" height="17px" version="1.1" x="0" y="0" viewBox="0 0 512 512"><g><path d="M448 232.148c-11.777 0-21.332-9.554-21.332-21.332 0-59.84-23.297-116.074-65.602-158.402-8.34-8.34-8.34-21.82 0-30.164 8.34-8.34 21.825-8.34 30.164 0 50.372 50.367 78.102 117.336 78.102 188.566 0 11.778-9.555 21.332-21.332 21.332zM21.332 232.148C9.559 232.148 0 222.594 0 210.816 0 139.586 27.734 72.617 78.102 22.25c8.34-8.34 21.824-8.34 30.164 0 8.343 8.344 8.343 21.824 0 30.164C65.96 94.72 42.668 150.977 42.668 210.816c0 11.778-9.559 21.332-21.336 21.332zM434.754 360.813C402.496 333.546 384 293.695 384 251.476V192c0-75.07-55.766-137.215-128-147.625V21.332C256 9.535 246.441 0 234.668 0c-11.777 0-21.336 9.535-21.336 21.332v23.043c-72.254 10.41-128 72.555-128 147.625v59.477c0 42.218-18.496 82.07-50.941 109.503a37.262 37.262 0 0 0-13.059 28.352c0 20.59 16.746 37.336 37.336 37.336h352c20.586 0 37.332-16.746 37.332-37.336 0-10.922-4.758-21.246-13.246-28.52zM234.668 512c38.633 0 70.953-27.543 78.379-64H156.289c7.422 36.457 39.742 64 78.379 64zm0 0" opacity="1"/></g>
                                    </svg>
                                    <span>Alert Settings</span>
                                </div>
                            }  
                              disabled={!campaignDetails?.prof_campaign_id}>
                                <div className="fp-camp-step2">
                                    <AlertSetting  
                                    changeTab1={activeTab} 
                                    tab={activeTab} 
                                    camapaignDetails={campaignDetails} 
                                    products={products} 
                                    projects={structuredClone(projects)}
                                    changeTab={handleTabChange}
                                    selectedAlertType = {selectedAlertType} 
                                    // updateCamapaign = {handleCamapaignUpdate}
                                    />
                                </div>
                            </Tab>
                            <Tab eventKey="tab3" title={
                                <div className="fp_front_icons">
                                    <svg width="17px" height="17px" version="1.1" x="0" y="0" viewBox="0 0 28 28"><g><g data-name="Layer 2"><path d="M22.6 1H5.4A4.4 4.4 0 0 0 1 5.4V7h26V5.4A4.4 4.4 0 0 0 22.6 1zM5 5a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm3 0a1 1 0 1 1 1-1 1 1 0 0 1-1 1zM15.656 19.646a2.333 2.333 0 1 0-3.3.01 2.4 2.4 0 0 0 3.3-.01z" opacity="1"/><path d="M1 22.6A4.4 4.4 0 0 0 5.4 27h17.2a4.4 4.4 0 0 0 4.4-4.4V9H1zM9 17h.8a4.3 4.3 0 0 1 .524-1.266l-.56-.56a1 1 0 1 1 1.414-1.414l.561.561A4.294 4.294 0 0 1 13 13.8V13a1 1 0 0 1 2 0v.8a4.3 4.3 0 0 1 1.266.524l.56-.56a1 1 0 1 1 1.414 1.414l-.561.561A4.3 4.3 0 0 1 18.2 17h.8a1 1 0 0 1 0 2h-.8a4.3 4.3 0 0 1-.524 1.266l.56.56a1 1 0 1 1-1.414 1.414l-.561-.561A4.294 4.294 0 0 1 15 22.2v.8a1 1 0 0 1-2 0v-.8a4.3 4.3 0 0 1-1.266-.524l-.56.56a1 1 0 1 1-1.414-1.41l.561-.561A4.3 4.3 0 0 1 9.8 19H9a1 1 0 0 1 0-2z" opacity="1"/></g></g></svg>
                                    <span>Page Settings</span>
                                </div>
                            }  disabled={!campaignDetails?.prof_campaign_id}>
                              {<PageSetting 
                              selectedAlert={selectedAlert} 
                              camapaignDetails={campaignDetails} 
                              pageSettings={pageSettings} 
                              projects={structuredClone(projects)}
                              activeTabChange = {activeTab}
                              changeTab={() => {
                                        setActiveTab("tab4")
                                        setIsPublishedUrlLoading(true)
                                        getPageSettings({ user_id: userDetails.user.id, token: userDetails.token, prof_campaign_id: campaignDetails?.prof_campaign_id })
                                        getPublishUrlData({ user_id: userDetails.user.id, token: userDetails.token, prof_campaign_id: campaignDetails?.prof_campaign_id })
                                    }}
                               />}
                            </Tab>

                            <Tab eventKey="tab4" title={
                                <div className="fp_front_icons">
                                    <svg width="18px" height="18px" version="1.1" x="0" y="0" viewBox="0 0 512 512"><g><path fillRule="evenodd" d="m379.32 292.375-24.05-66.978c-1.61-4.438.704-9.318 5.132-10.918 4.428-1.59 9.308.714 10.918 5.152l16.051 44.634 16.05-44.634a8.508 8.508 0 0 1 8-5.655c3.623 0 6.843 2.259 8.051 5.655l16.05 44.634 16.05-44.634c1.56-4.438 6.44-6.742 10.918-5.152 4.428 1.6 6.742 6.48 5.132 10.918l-24.101 66.978a8.51 8.51 0 0 1-8 5.65c-3.622 0-6.843-2.259-8.05-5.65l-16.051-44.644-16.05 44.644a8.51 8.51 0 0 1-8 5.65c-3.622 0-6.842-2.259-8.05-5.65zM160.251 470.151c-9.208-13.027-17.51-27.96-24.805-44.352-18.415 5.303-35.673 11.869-51.472 19.602 29.887 27.19 66.264 47.401 106.466 58.068-10.667-8.88-20.78-20.02-30.189-33.318zm86.742 41.278c-26.315-3.256-51.321-20.77-72.805-51.145-8.1-11.456-15.497-24.533-22.038-38.893 29.635-7.089 61.685-11.089 94.843-11.698zm90.818-51.145c8.1-11.456 15.497-24.533 22.038-38.893-29.887-7.155-62.289-11.165-95.799-11.718v101.872c26.667-2.954 52.025-20.524 73.761-51.261zm90.214-14.883c-29.887 27.19-66.264 47.401-106.466 58.068 10.667-8.88 20.78-20.02 30.189-33.318 9.207-13.027 17.509-27.96 24.805-44.352 18.415 5.303 35.673 11.869 51.472 19.602zM403.27 334.226c-4.478 26.933-11.371 52.523-20.227 75.698 20.83 6.113 40.302 13.771 57.912 22.873 26.466-27.683 46.793-61.283 58.818-98.571zm-139.22 0h121.912c-4.428 25.449-11.019 49.515-19.471 71.24-31.95-7.879-66.616-12.287-102.44-12.861v-58.379zm-135.144 75.698c-20.78 6.113-40.252 13.781-57.862 22.873-26.465-27.683-46.792-61.283-58.818-98.571h96.503c4.478 26.933 11.371 52.524 20.177 75.698zm118.087-75.698H126.037c4.428 25.449 11.019 49.515 19.472 71.24 31.648-7.814 66.013-12.211 101.484-12.85zM145.509 106.533c-8.453 21.726-15.044 45.791-19.472 71.24h120.956v-58.39c-35.471-.638-69.836-5.031-101.484-12.85zm-16.603-4.462c-8.805 23.18-15.698 48.77-20.176 75.703H12.226c12.025-37.293 32.352-70.888 58.818-98.566 17.61 9.096 37.082 16.754 57.862 22.863zm6.54-15.86c7.296-16.403 15.598-31.336 24.805-44.362 9.409-13.298 19.522-24.433 30.189-33.318-40.201 10.667-76.579 30.878-106.466 58.068 15.799 7.733 33.057 14.304 51.472 19.612zm111.547 16.096c-33.158-.604-65.207-4.609-94.843-11.698 6.541-14.36 13.937-27.436 22.038-38.893 21.484-30.375 46.49-47.89 72.805-51.145zm112.856-11.698c-6.541-14.36-13.937-27.436-22.038-38.893C316.075 20.979 290.717 3.409 264.05.455v101.877c33.51-.558 65.912-4.569 95.799-11.723zm16.704-4.398c-7.296-16.403-15.598-31.336-24.805-44.362-9.409-13.298-19.522-24.433-30.189-33.318 40.201 10.667 76.579 30.878 106.466 58.068-15.799 7.733-33.057 14.304-51.472 19.612zm6.491 15.86c8.855 23.18 15.749 48.77 20.227 75.703h96.453c-11.975-37.293-32.302-70.888-58.767-98.566-17.611 9.096-37.083 16.754-57.913 22.863zM264.05 177.773v-58.38c35.824-.574 70.49-4.976 102.44-12.861 8.453 21.726 15.044 45.791 19.471 71.24H264.05zM512 255.997c0-21.076-2.566-41.555-7.397-61.157H7.396C2.566 214.443 0 234.921 0 255.997c0 21.082 2.566 41.56 7.396 61.162h497.207c4.831-19.602 7.397-40.08 7.397-61.162zm-199.799-30.601L288.1 292.375c-1.207 3.391-4.428 5.65-8.05 5.65a8.51 8.51 0 0 1-8-5.65L256 247.73l-16.05 44.644a8.51 8.51 0 0 1-8 5.65c-3.623 0-6.843-2.259-8.05-5.65l-24.101-66.978c-1.559-4.438.755-9.318 5.183-10.918 4.427-1.59 9.308.714 10.918 5.152l16.05 44.634 16-44.634c1.208-3.396 4.478-5.655 8.05-5.655 3.623 0 6.793 2.259 8.05 5.655l16 44.634 16.05-44.634c1.61-4.438 6.491-6.742 10.918-5.152 4.479 1.6 6.743 6.48 5.183 10.918zm-155.472 0-24.05 66.978c-1.208 3.391-4.428 5.65-8.051 5.65a8.51 8.51 0 0 1-8-5.65l-16.05-44.644-16.05 44.644c-1.207 3.391-4.428 5.65-8.05 5.65a8.51 8.51 0 0 1-8-5.65l-24.101-66.978c-1.61-4.438.704-9.318 5.132-10.918 4.428-1.59 9.359.714 10.918 5.152l16.05 44.634 16.05-44.634a8.524 8.524 0 0 1 8.05-5.655 8.506 8.506 0 0 1 8 5.655l16.05 44.634 16.051-44.634c1.61-4.438 6.49-6.742 10.918-5.152 4.429 1.6 6.743 6.48 5.133 10.918z" clipRule="evenodd" opacity="1"/></g></svg>
                                    <span>Published Page URL</span>
                                </div>
                            } disabled={!campaignDetails?.prof_campaign_id}>
                              {<PublicUrl  publishUrlData={publishData} alertTab={activeTab}  isLoading={isPublishedUrlLoading}/>}
                            </Tab>
                            
                        </Tabs>
                    </div>

                </div>
            </div>
        </>
    )
}